import { render, staticRenderFns } from "./examineResult.vue?vue&type=template&id=702b9e9e&scoped=true"
import script from "./examineResult.vue?vue&type=script&lang=js"
export * from "./examineResult.vue?vue&type=script&lang=js"
import style0 from "./examineResult.vue?vue&type=style&index=0&id=702b9e9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702b9e9e",
  null
  
)

export default component.exports